/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getBloodBankInventories } from 'app/entities/blood-bank-inventory/blood-bank-inventory.reducer';
import { getEntities as getBloodBankRequests } from 'app/entities/blood-bank-request/blood-bank-request.reducer';
import { getEntities as getBloodBanks } from 'app/entities/blood-bank/blood-bank.reducer';
import { createEntity, getEntity, reset, updateEntity } from './blood-inventory-request-map.reducer';

export const BloodInventoryRequestMapUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const bloodBankInventories = useAppSelector(state => state.bloodBankInventory.entities);
  const bloodBankRequests = useAppSelector(state => state.bloodBankRequest.entities);
  const bloodBanks = useAppSelector(state => state.bloodBank.entities);
  const bloodInventoryRequestMapEntity = useAppSelector(state => state.bloodInventoryRequestMap.entity);
  const loading = useAppSelector(state => state.bloodInventoryRequestMap.loading);
  const updating = useAppSelector(state => state.bloodInventoryRequestMap.updating);
  const updateSuccess = useAppSelector(state => state.bloodInventoryRequestMap.updateSuccess);

  const handleClose = () => {
    navigate(`/blood-inventory-request-map${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getBloodBankInventories({}));
    dispatch(getBloodBankRequests({}));
    dispatch(getBloodBanks({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.servedBagNumber !== undefined && typeof values.servedBagNumber !== 'number') {
      values.servedBagNumber = Number(values.servedBagNumber);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...bloodInventoryRequestMapEntity,
      ...values,
      fromInventory: bloodBankInventories.find(it => it.id.toString() === values.fromInventory?.toString()),
      forRequest: bloodBankRequests.find(it => it.id.toString() === values.forRequest?.toString()),
      bank: bloodBanks.find(it => it.id.toString() === values.bank?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...bloodInventoryRequestMapEntity,
          fromInventory: bloodInventoryRequestMapEntity?.fromInventory?.id,
          forRequest: bloodInventoryRequestMapEntity?.forRequest?.id,
          bank: bloodInventoryRequestMapEntity?.bank?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.bloodInventoryRequestMap.home.createOrEditLabel" data-cy="BloodInventoryRequestMapCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.bloodInventoryRequestMap.home.createOrEditLabel">
              Create or edit a BloodInventoryRequestMap
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="blood-inventory-request-map-id"
                  label={translate('tinyMedicRestApp.bloodInventoryRequestMap.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryRequestMap.servedBagNumber')}
                id="blood-inventory-request-map-servedBagNumber"
                name="servedBagNumber"
                data-cy="servedBagNumber"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryRequestMap.active')}
                id="blood-inventory-request-map-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryRequestMap.cursor')}
                id="blood-inventory-request-map-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryRequestMap.lastUpdated')}
                id="blood-inventory-request-map-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryRequestMap.microSec')}
                id="blood-inventory-request-map-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodInventoryRequestMap.timestampEntry')}
                id="blood-inventory-request-map-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="blood-inventory-request-map-fromInventory"
                name="fromInventory"
                data-cy="fromInventory"
                label={translate('tinyMedicRestApp.bloodInventoryRequestMap.fromInventory')}
                type="select"
              >
                <option value="" key="0" />
                {bloodBankInventories
                  ? bloodBankInventories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-inventory-request-map-forRequest"
                name="forRequest"
                data-cy="forRequest"
                label={translate('tinyMedicRestApp.bloodInventoryRequestMap.forRequest')}
                type="select"
              >
                <option value="" key="0" />
                {bloodBankRequests
                  ? bloodBankRequests.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-inventory-request-map-bank"
                name="bank"
                data-cy="bank"
                label={translate('tinyMedicRestApp.bloodInventoryRequestMap.bank')}
                type="select"
              >
                <option value="" key="0" />
                {bloodBanks
                  ? bloodBanks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/blood-inventory-request-map" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BloodInventoryRequestMapUpdate;
